import { useState } from 'react';
import { NavLink, Outlet, useOutletContext } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LayoutDashboard, Users, CreditCard, SlidersHorizontal, Plus, QrCode, Shuffle } from 'lucide-react';
import NewSaleModal from './NewSaleModal';
import CardSaleModal from './CardSaleModal';

const SUBNAV = [
  { to: '/admin/sales', end: true, label: 'Dashboard', icon: LayoutDashboard, testid: 'sales-nav-dashboard' },
  { to: '/admin/sales/clients', label: 'Clients', icon: Users, testid: 'sales-nav-clients' },
  { to: '/admin/sales/cards', label: 'Cards', icon: CreditCard, testid: 'sales-nav-cards' },
  { to: '/admin/sales/draws', label: 'Draws', icon: Shuffle, testid: 'sales-nav-draws' },
  { to: '/admin/sales/settings', label: 'Settings', icon: SlidersHorizontal, testid: 'sales-nav-settings' },
];

export default function SalesLayout() {
  const parentCtx = useOutletContext();
  const [newSaleOpen, setNewSaleOpen] = useState(false);
  const [cardSaleOpen, setCardSaleOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="admin-root">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-6">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: '#90E0EF', boxShadow: '0 0 8px rgba(144,224,239,0.7)' }} />
            <h1 className="font-outfit text-2xl font-semibold text-white tracking-tight">Sales</h1>
          </div>
          <p className="text-[11px] font-mono text-[#777] mt-1">Live gallery sales terminal — Mr. Relative &amp; The Relative Gallery.</p>
        </div>
        <div className="flex items-center gap-3">
          <motion.button
            whileHover={{ y: -1.5 }} whileTap={{ scale: 0.97 }}
            onClick={() => setCardSaleOpen(true)}
            data-testid="card-sale-open-btn"
            style={{ cursor: 'pointer' }}
            className="inline-flex items-center gap-2 px-5 py-3 text-[11px] font-mono uppercase tracking-[0.2em] font-medium border border-[#2a2a2a] text-[#ddd] hover:text-white hover:border-[#90E0EF]/60 transition-colors"
          >
            <QrCode className="w-4 h-4" /> Card Sale
          </motion.button>
          <motion.button
            whileHover={{ y: -1.5 }} whileTap={{ scale: 0.97 }}
            onClick={() => setNewSaleOpen(true)}
            data-testid="new-sale-open-btn"
            style={{ cursor: 'pointer', background: '#90E0EF', color: '#050505' }}
            className="inline-flex items-center gap-2 px-5 py-3 text-[11px] font-mono uppercase tracking-[0.2em] font-medium"
          >
            <Plus className="w-4 h-4" /> New Sale
          </motion.button>
        </div>
      </div>

      <nav className="flex items-center gap-1 border-b border-[#1a1a1a] mb-8 overflow-x-auto">
        {SUBNAV.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            data-testid={it.testid}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-3 text-[11px] font-mono uppercase tracking-[0.14em] border-b-2 transition-all whitespace-nowrap ${
                isActive ? 'border-[#90E0EF] text-[#90E0EF]' : 'border-transparent text-[#777] hover:text-[#ddd]'
              }`
            }
          >
            <it.icon className="w-3.5 h-3.5" /> {it.label}
          </NavLink>
        ))}
      </nav>

      <Outlet context={{ ...parentCtx, refreshKey, requestRefresh: () => setRefreshKey((k) => k + 1) }} />

      <NewSaleModal open={newSaleOpen} onClose={() => setNewSaleOpen(false)} onCreated={() => setRefreshKey((k) => k + 1)} />
      <CardSaleModal open={cardSaleOpen} onClose={() => setCardSaleOpen(false)} />
    </div>
  );
}
